/* src/app/pages/ui-kit/components/summary-cards-view/summary-cards-view.component.scss */
.demo {
  display: grid;
  gap: 24px;
}
.demo__caption {
  margin: 0 0 16px;
  color: var(--text-subtle);
  font-size: 14px;
  line-height: 20px;
}
/*# sourceMappingURL=summary-cards-view.component.css.map */
